import { jsx } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { Message } from "../Message/Message.js";
import { useClassNamePrefix } from "../../auxiliary/useClassNamePrefix.js";
const ErrorList = memo(({ errors = [] }) => {
  const prefix = useClassNamePrefix();
  const messages = useMemo(() => [...new Set(errors.map((it) => it.message))], [errors]);
  if (!messages.length) {
    return null;
  }
  return /* @__PURE__ */ jsx("ul", { className: `${prefix}errorList`, children: messages.map((error) => /* @__PURE__ */ jsx("li", { className: `${prefix}errorList-item`, children: /* @__PURE__ */ jsx(Message, { intent: "danger", size: "small", children: error }) }, error)) });
});
ErrorList.displayName = "ErrorList";
export {
  ErrorList
};
//# sourceMappingURL=ErrorList.js.map
